import {Component, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {TranslatePipe} from '@ngx-translate/core';

import '@datev/dacks/app-switch';
import '@datev/dacks/header';
import '@datev/dacks/client-flyout';
import '@datev/dacks/icon';
import '@datev/dacks/help-menu';
import '@datev/dacks/local-nav';
import '@datev/dacks/notifications';
import '@datev/dacks/user-menu';


@Component({
    selector: 'myupdates-app-local-nav',
    templateUrl: './app-local-nav.component.html',
    styleUrls: ['./app-local-nav.component.scss'],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [RouterLink, RouterLinkActive, TranslatePipe]
})
export class AppLocalNavComponent {

  constructor() {
  }

}
